import { ProIp } from "./ApiURL";


// Post Mapping :id  institute id

export const getLinksAPI = ProIp + "Links/getLinks/mob/";


//Post Mapping

export const saveLinksAPI = ProIp + "Links/saveLinks/mob";


//post Mapping
export const deleteLinkAPI = ProIp + "Links/deleteLinks/mob";